import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { useReveal } from "@/hooks/useReveal";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Story } from "@/components/Story";
import { Gallery } from "@/components/Gallery";
import { Audiences } from "@/components/Audiences";
import { Process } from "@/components/Process";
import { Workshop } from "@/components/Workshop";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const Home = () => {
  const ref = useReveal();

  return (
    <div ref={ref} className="bg-[#FBF9F5] text-[#241F1C] antialiased min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Story />
        <Gallery />
        <Audiences />
        <Process />
        <Workshop />
        <Testimonials />
        <Faq />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

const ProtectedAdmin = () => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[#FBF9F5] flex items-center justify-center text-sm text-[#8C7A6B]">
        Laden...
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }
  return <AdminDashboard />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedAdmin />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
